export class GameProgress {
    private _isFirstVisit: boolean;
    private _isOnboardingComplete: boolean;
    private _saveData: any[];
    private _recentItemIndex: number;
    private _cachedGalleryVisuals: PIXI.Texture | undefined;
    private _funFactUniqueIndex: number[];
    private _funFactCommonIndex: number;

    constructor(pItemCount: number) {
        this._isFirstVisit = true;
        this._isOnboardingComplete = false;
        this._recentItemIndex = -1;
        this._saveData = new Array<any>(pItemCount);
        this._funFactUniqueIndex = new Array<number>(2);
        for (let i = 0; i < this._funFactUniqueIndex.length; ++i) {
            this._funFactUniqueIndex[i] = 0;
        }
        this._funFactCommonIndex = 0;
    }

    public get isFirstVisit(): boolean {
        return this._isFirstVisit;
    }

    public set isFirstVisit(pValue: boolean) {
        this._isFirstVisit = pValue;
    }

    public get isOnboardingComplete(): boolean {
        return this._isOnboardingComplete;
    }

    public set isOnboardingComplete(pValue: boolean) {
        this._isOnboardingComplete = pValue;
    }

    public get saveData(): any[] {
        return this._saveData;
    }

    public get cachedGalleryVisuals(): PIXI.Texture | undefined {
        return this._cachedGalleryVisuals;
    }

    public set cachedGalleryVisuals(pValue: PIXI.Texture | undefined) {
        this._cachedGalleryVisuals = pValue;
    }

    public get recentItemIndex(): number {
        return this._recentItemIndex;
    }

    public set recentItemIndex(pValue: number) {
        this._recentItemIndex = pValue;
    }

    public get funFactUniqueIndex(): number[] {
        return this._funFactUniqueIndex;
    }

    public get funFactCommonIndex(): number {
        return this._funFactCommonIndex;
    }

    public set funFactCommonIndex(pValue: number) {
        this._funFactCommonIndex = pValue;
    }
}
